import { render, staticRenderFns } from "./openCourse.vue?vue&type=template&id=7d312ec3&scoped=true"
import script from "./openCourse.vue?vue&type=script&lang=js"
export * from "./openCourse.vue?vue&type=script&lang=js"
import style0 from "./openCourse.vue?vue&type=style&index=0&id=7d312ec3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d312ec3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d312ec3')) {
      api.createRecord('7d312ec3', component.options)
    } else {
      api.reload('7d312ec3', component.options)
    }
    module.hot.accept("./openCourse.vue?vue&type=template&id=7d312ec3&scoped=true", function () {
      api.rerender('7d312ec3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collegeEdition/openCourse.vue"
export default component.exports